module.exports = __webpack_public_path__ + "media/WR Blob 15.3706f8da.mp3";